/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_Effort_Easy_TimeInputs */

const en_us2_workout_quick_effort_easy_time = /** @type {(inputs: Workout_Quick_Effort_Easy_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`plenty left`)
};

const pt_br2_workout_quick_effort_easy_time = /** @type {(inputs: Workout_Quick_Effort_Easy_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dava bem mais`)
};

const es_419_workout_quick_effort_easy_time = /** @type {(inputs: Workout_Quick_Effort_Easy_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`quedaba mucho`)
};

const pt_pt2_workout_quick_effort_easy_time = /** @type {(inputs: Workout_Quick_Effort_Easy_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dava bem mais`)
};

const fr_fr2_workout_quick_effort_easy_time = /** @type {(inputs: Workout_Quick_Effort_Easy_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`encore de la marge`)
};

const de_de2_workout_quick_effort_easy_time = /** @type {(inputs: Workout_Quick_Effort_Easy_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`viel übrig`)
};

const it_it2_workout_quick_effort_easy_time = /** @type {(inputs: Workout_Quick_Effort_Easy_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ne avevo ancora molto`)
};

/**
* | output |
* | --- |
* | "plenty left" |
*
* @param {Workout_Quick_Effort_Easy_TimeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_effort_easy_time = /** @type {((inputs?: Workout_Quick_Effort_Easy_TimeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Effort_Easy_TimeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_effort_easy_time(inputs)
	if (locale === "es-419") return es_419_workout_quick_effort_easy_time(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_effort_easy_time(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_effort_easy_time(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_effort_easy_time(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_effort_easy_time(inputs)
	return en_us2_workout_quick_effort_easy_time(inputs)
});
export { workout_quick_effort_easy_time as "workout-quick.effort_easy_time" }